const M = [
  {
    name: "eepay",
    zh: "易付宝",
    en: "eepay"
  },
  {
    name: "download",
    zh: "APP下载",
    en: "APP Download"
  },
  {
    name: "customerService",
    zh: "联系客服",
    en: "Customer Service"
  },
  {
    name: "payment",
    zh: "付款",
    en: "Payment"
  },
  {
    name: "receive",
    zh: "收款",
    en: "Receive"
  },
  {
    name: "paymentCode",
    zh: "付款码",
    en: "Payment code"
  },
  {
    name: "receiveCode",
    zh: "收款码",
    en: "Receive code"
  },
  {
    name: "eepayScanPayMe",
    zh: "易付宝扫一扫，向我付款",
    en: "eepay scan, pay for me"
  },
  {
    name: "removeAmount",
    zh: "清除金额",
    en: "Remove the amount"
  },
  {
    name: "setAmount",
    zh: "设置金额",
    en: "Set the amount"
  },
  {
    name: "saveImage",
    zh: "保存图片",
    en: "Save the image"
  },
  {
    name: "receiveRecords",
    zh: "收款记录",
    en: "Receive history"
  },
  {
    name: "amount",
    zh: "金额",
    en: "Amount"
  },
  {
    name: "addReason",
    zh: "添加收钱理由",
    en: "Add reason to charge"
  },
  {
    name: "reason",
    zh: "理由",
    en: "Reason"
  },
  {
    name: "enterReason",
    zh: "请输入理由",
    en: "Enter reason"
  }
];

export default M;
